import { Star, ThumbDown, ThumbUp } from '@mui/icons-material';
import { Box, Divider, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const classes = {
	icon: {
		color: 'grey',
	},
	starIcon: {
		color: 'rgb(250, 175, 0)',
	},
	hiddenIcon: {
		width: 28,
		height: 14,
		bgcolor: '#9E9E9E',
		position: 'relative',
		margin: '4px',
	},
	divider: {
		position: 'absolute',
		left: '50%',
		top: 0,
		bottom: 0,
		borderColor: '#D4D4D4',
	},
	hiddenIconsColor: {
		color: '#BDBDBD',
	},
};
const RatingAndRecommendation = ({ feedbackInfo, view }) => {
	const { t } = useTranslation(['candidate-feedback', 'common']);
	if (view !== 'feedbackTabView') {
		return null;
	}

	const recommendationStatus = {
		0: {
			text: t('not_recommended'),
			icon: <ThumbDown sx={classes.icon} />,
		},
		2: {
			text: t('recommended'),
			icon: <ThumbUp sx={classes.icon} />,
		},
	};

	const isRatingMasked = Number(feedbackInfo.rating) === -1.0;
	const isRecommendationMasked = feedbackInfo.recommended === 'MASKED';

	return (
		<Box sx={{ display: 'flex', justifyContent: 'end', height: '20px', marginY: '4px' }}>
			{isRatingMasked ? (
				<Tooltip title={t('visible_once_you_have_submitted_your_feedback')} placement="top">
					<Box display="flex" alignItems="start" gap={0} role="presentation" aria-hidden="true">
						<Star sx={{ ...classes.hiddenIconsColor }} />
						<Box sx={{ ...classes.hiddenIcon }} role="presentation" aria-hidden="true">
							<Divider
								orientation="vertical"
								sx={{
									...classes.divider,
								}}
							/>
						</Box>
					</Box>
				</Tooltip>
			) : (
				!isRatingMasked &&
				feedbackInfo.rating > 0 && (
					<>
						<p className="screenreader">
							{t('average_rating_aria_label', {
								averageRating: Number(feedbackInfo.rating)?.toFixed(1),
							})}
						</p>
						<Box display="flex" alignItems="center">
							<Star sx={classes.starIcon} />
							<Typography variant="body2" marginLeft="4px" data-testid="rating" aria-hidden="true">
								{Number(feedbackInfo.rating)?.toFixed(1)}
							</Typography>
						</Box>
					</>
				)
			)}

			{isRecommendationMasked ? (
				<Tooltip title={t('visible_once_you_have_submitted_your_feedback')} placement="top">
					<Box
						display="flex"
						alignItems="start"
						marginLeft={1}
						role="presentation"
						aria-hidden="true"
					>
						<ThumbUp sx={{ ...classes.hiddenIconsColor }} />
						<Box sx={{ ...classes.hiddenIcon }} role="presentation" aria-hidden="true">
							<Divider
								orientation="vertical"
								sx={{
									...classes.divider,
								}}
							/>
						</Box>
					</Box>
				</Tooltip>
			) : (
				typeof feedbackInfo.recommended !== 'undefined' &&
				feedbackInfo.recommended !== null && (
					<>
						<p className="screenreader">
							{t('recommendation_aria_label', {
								status: recommendationStatus[feedbackInfo.recommended].text,
							})}
						</p>
						<Box display="flex" marginLeft={1} alignItems="center">
							<>
								{recommendationStatus[feedbackInfo.recommended].icon}
								<Typography
									variant="body2"
									marginLeft={1}
									data-testid="recommended"
									aria-hidden="true"
								>
									{recommendationStatus[feedbackInfo.recommended].text}
								</Typography>
							</>
						</Box>
					</>
				)
			)}
		</Box>
	);
};

export default RatingAndRecommendation;
